// Layout verification module
// Used to verify that JavaScript is loading properly in all layouts

console.log("Layout verification module loaded");

// Function to log layout information
export function verifyLayout() {
  const body = document.querySelector("body");
  const layoutClass = Array.from(body.classList)
    .find(cls => cls.startsWith('layout-')) || 'No layout class found';
  const layoutData = body.dataset.layout || 'No layout data attribute found';
  
  console.log(`
    ==== Layout Verification ====
    Body class: ${layoutClass}
    Layout data attribute: ${layoutData}
    Document title: ${document.title}
    URL: ${window.location.href}
    JavaScript successfully loaded
    ===========================
  `);
  
  // Return verification data for testing
  return {
    layoutClass,
    layoutData,
    title: document.title,
    url: window.location.href
  };
}

// Auto-run the verification
document.addEventListener("DOMContentLoaded", () => {
  verifyLayout();
});